export default [
  {
    key: 'startDate',
    label: 'field.fromDate',
    type: 'date',
    cols: 3,
  },
  {
    key: 'toDate',
    label: 'field.toDate',
    type: 'date',
    cols: 3,
  },
  {
    key: 'portfolio',
    label: 'field.game',
    type: 'singleSelect',
    options: [
      { name: 'Football', id: 'SPORT99' },
      { name: 'AFB Sport', id: 'AFBSPORT' },
      { name: 'Casino', id: 'CASINO' },
      { name: 'Casino 2', id: 'CASINO2' },
    ],
    reduce: true,
    clearable: true,
    cols: 6,
  },
  {
    key: 'period',
    label: 'field.period',
    type: 'radio',
    options: [
      { text: 'field.today', value: 'today' },
      { text: 'field.yesterday', value: 'yesterday' },
      { text: 'field.thisWeek', value: 'thisWeek' },
      { text: 'field.lastWeek', value: 'lastWeek' },
      { text: 'field.thisMonth', value: 'thisMonth' },
      { text: 'field.lastMonth', value: 'lastMonth' },
    ],
    cols: 6,
  },
]
